import React from 'react';
import classNames from 'classnames';

const SubChapter = ({ name, className, textColor }) => {
  return (
    <div className={classNames('subchapter', className)}>
      <div className="title custom-font-body" style={{ color: textColor }}>
        {name}
      </div>
    </div>
  );
};

export default SubChapter;
